export default () => {
  if ($('.subnav-center').length) {
    // enables keyboard tabbing
    $('html').on('focus blur', '.subnav-center-item.-has-children', (e) => {
      const $target = $(e.currentTarget);
      e.type === 'focusin' ? $target.addClass('-dropdown-open') : $target.removeClass('-dropdown-open');
    });
  }
};